import * as React from "react"
import { RouteComponentProps } from "@reach/router"
import { CreateOrganizationWizard } from "../../modules/organization/create/components/CreateOrganizationWizard"

export function CreateOrganization(props: RouteComponentProps) {
  return <CreateOrganizationWizard location={props.location} />
}
